import React, {useState} from "react";
import connection from "../../connection";
import Connection from "../../connection";
import general from "../../general";
import withStyles from "@material-ui/core/styles/withStyles";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Button from "components/CustomButtons/Button.jsx";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFileDownload, faFileExcel, faTrashAlt} from "@fortawesome/free-solid-svg-icons";

import modulosStyle from "assets/jss/material-dashboard-pro-react/views/modulosStyle.jsx";
import SweetAlert from "components/SweetAlertWrapper";
import ReactTable from "components/ReactTableWrapper";
import CustomInput from "../../components/CustomInput/CustomInput";
import {Add, Create, Visibility} from "@material-ui/icons";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import {ContentState, convertFromHTML, convertToRaw, EditorState} from 'draft-js'
import draftToHtml from 'draftjs-to-html';
import {Editor} from "react-draft-wysiwyg";
import Tooltip from "@material-ui/core/Tooltip";
import {primaryColor} from "../../assets/jss/material-dashboard-pro-react";
import Parser from "html-react-parser";
import CardBody from "../../components/Card/CardBody";

class Catalogo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: null,
      areas: null,
      modulos: null
    };

    this.hideModal = this.hideModal.bind(this);

    this.reloadModulos = async () => {
      this.setState({modulos: await connection.get("modulo/listagem")});
    };
    this.reloadAreas = async () => {
      this.setState({areas: await connection.get("modulo/area/listagem")});
    };
  }

  componentDidMount() {
    this.reloadModulos();
    if (general.userHasPermission("modulo.editar"))
      this.reloadAreas();
  }

  hideModal() {
    this.setState({modal: null});
  }

  render() {
    const {classes} = this.props;

    return (<div>
      {this.state.modal}
      <GridContainer>
        <GridItem xs={12}>
          <this.CardModulos/>
          {general.userHasPermission("modulo.editar") && <this.CardAreas/>}
        </GridItem>
      </GridContainer>
    </div>);
  }

  CardAreas = () => {
    const [filter, setFilter] = useState("");
    const {classes} = this.props;

    return <Card>
      <CardHeader color="primary">
        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
          <h4 style={{flex: 1}}>Áreas</h4>
          <CustomInput
            formControlProps={{
              className: classes.searchInput
            }}
            inputProps={{
              type: "text",
              placeholder: "Pesquisar",
              onChange: (e) => {
                setFilter(e.target.value);
              }
            }}
          />
          <Button className={classes.addCourseButton + " " + classes.button + " " + classes.primary} onClick={this.novaAreaModal}>
            <Add/> Nova Área
          </Button>
        </div>
      </CardHeader>
      <ReactTable
        data={general.filterTable(this.state.areas, filter)}
        minRows={1}
        columns={[
          {
            Header: "Código",
            accessor: "codigo",
            width: 120
          },
          {
            Header: "Área",
            accessor: "designacao"
          },
          {
            Header: "Módulos",
            accessor: "numero_modulos"
          },
          {
            Header: "",
            accessor: "actions",
            width: 120,
            sortable: false,
            Cell: (row) => {
              row = row.original;
              return [<Button
                justIcon
                round
                simple
                style={{margin: 0}}
                onClick={(e) => {
                  e.stopPropagation();
                  this.editAreaModal(row);
                }}
                className={classes.editButton}
              >
                <Create/>
              </Button>,
                <Button
                  justIcon
                  round
                  simple
                  style={{margin: 0}}
                  onClick={() => {
                    this.setState({
                      modal: (
                        <SweetAlert
                          warning
                          title="Apagar Área"
                          onConfirm={async () => {
                            await connection.post("modulo/area/apagar", {id: row.id});
                            this.hideModal();
                            this.reloadAreas();
                            general.success("Área apagada com sucesso", "Sucesso");
                          }}
                          onCancel={() => this.hideModal()}
                          confirmBtnCssClass={
                            this.props.classes.button + " " + this.props.classes.danger
                          }
                          cancelBtnCssClass={
                            this.props.classes.button
                          }
                          confirmBtnText="Apagar"
                          cancelBtnText="Cancelar"
                          showCancel
                        >
                          Tem a certeza que pretende apagar esta área? Não é possível apagar áreas em utilização.
                        </SweetAlert>
                      )
                    });
                  }}
                  color="danger"
                  className="edit"
                >
                  <FontAwesomeIcon icon={faTrashAlt}/>
                </Button>];
            }
          }
        ]}
        defaultPageSize={5}
        showPaginationBottom={true}
        className="-striped -highlight"
      />
    </Card>
  };

  CardModulos = () => {
    const [filter, setFilter] = useState("");
    const {classes} = this.props;

    return <Card>
      <CardHeader color="primary">
        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
          <h4 style={{flex: 1}}>Módulos</h4>
          <CustomInput
            formControlProps={{
              className: classes.searchInput
            }}
            inputProps={{
              type: "text",
              placeholder: "Pesquisar",
              onChange: (e) => {
                setFilter(e.target.value);
              }
            }}
          />
          {general.userHasPermission("modulo.criar") && <Button className={classes.addCourseButton + " " + classes.button + " " + classes.primary} onClick={this.novoModuloModal}>
            <Add/> Novo Módulo
          </Button>}
          <a className={classes.addStuffButton + " " + classes.button + " " + classes.info}
             target={'_blank'}
             href={Connection.getFullUrl("modulo/listagem", {exportar_catalogo: true})}>
            <FontAwesomeIcon icon={faFileExcel}/> Exportar Listagem
          </a>
        </div>
      </CardHeader>
      <ReactTable
        data={general.filterTable(this.state.modulos, filter)}
        minRows={1}
        columns={[
          {
            Header: "Código",
            accessor: "codigo",
            width: 100
          },
          {
            Header: "Designação",
            accessor: "designacao"
          },
          {
            Header: "Área",
            accessor: "area"
          },
          {
            Header: "Grupo-alvo",
            accessor: "grupo_alvo",
            width: 250
          },
          {
            Header: "Créditos",
            accessor: "creditos",
            maxWidth: 120,
            Cell: row => <span>{row.value} {row.original.validade_creditos_meses > 0 && <small> ({row.original.validade_creditos_meses} meses de validade)</small>} </span>
          },
          {
            Header: "Isolado",
            accessor: "permitir_isolado",
            maxWidth: 100,
            Cell: row => <span>{row.value ? "Sim" : "Não"}</span>
          },
          {
            Header: "",
            accessor: "actions",
            width: 120,
            sortable: false,
            style: {textAlign: "right"},
            Cell: (row) => {
              row = row.original;
              return [
                general.userHasPermission("modulo.editar") ? <Button
                    justIcon
                    round
                    simple
                    style={{margin: 0}}
                    onClick={(e) => {
                      e.stopPropagation();
                      this.editModuloModal(row);
                    }}
                    className={classes.editButton}
                  >
                    <Create/>
                  </Button> :
                  <Button
                    justIcon
                    round
                    simple
                    style={{margin: 0}}
                    onClick={(e) => {
                      e.stopPropagation();
                      this.viewModuloModal(row);
                    }}
                    color={"info"}
                  >
                    <Visibility/>
                  </Button>,
                general.userHasPermission("modulo.apagar") && <Button
                  justIcon
                  round
                  simple
                  style={{margin: 0}}
                  onClick={() => {
                    this.setState({
                      modal: (
                        <SweetAlert
                          warning
                          title="Apagar Módulo"
                          onConfirm={async () => {
                            await connection.post("modulo/apagar", {id: row.id});
                            this.hideModal();
                            this.reloadAreas();
                            this.reloadModulos();
                            general.success("Módulo apagado com sucesso", "Sucesso");
                          }}
                          onCancel={() => this.hideModal()}
                          confirmBtnCssClass={
                            this.props.classes.button + " " + this.props.classes.danger
                          }
                          cancelBtnCssClass={
                            this.props.classes.button
                          }
                          confirmBtnText="Apagar"
                          cancelBtnText="Cancelar"
                          showCancel
                        >
                          Tem a certeza que pretende apagar este módulo? Não é possível apagar módulos em utilização.
                        </SweetAlert>
                      )
                    });
                  }}
                  color="danger"
                  className="edit"
                >
                  <FontAwesomeIcon icon={faTrashAlt}/>
                </Button>];
            }
          }
        ]}
        defaultPageSize={20}
        showPaginationBottom={true}
        className="-striped -highlight"
      />
    </Card>
  };

  editAreaModal = async (area) => {
    const {classes} = this.props;

    let Content = () => {
      return <form autoComplete="off" className={classes.addForm}>
        <CustomInput
          labelText="Código"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            defaultValue: area.codigo,
            onChange: (e) => {
              area.codigo = e.target.value;
            }
          }}
        />
        <CustomInput
          labelText="Designação"
          formControlProps={{
            fullWidth: true
          }}
          helpText="Utilize o formato: CODIGO | Designação"
          inputProps={{
            defaultValue: area.designacao,
            onChange: (e) => {
              area.designacao = e.target.value;
            }
          }}
        />
      </form>
    };

    this.setState({
      modal: (<SweetAlert
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Editar Área</span>
        </div>)}
        onConfirm={async () => {
          await connection.post("modulo/area/editar", {
            id: area.id,
            codigo: area.codigo,
            designacao: area.designacao,
          });
          this.hideModal();
          this.reloadAreas();
          this.reloadModulos();
          general.success("Área editada com sucesso", "Sucesso");
        }}
        onCancel={() => this.hideModal()}
        cancelBtnText="Cancelar"
        showCancel
        confirmBtnText="Salvar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <Content/>
      </SweetAlert>)
    });
  };

  novaAreaModal = async () => {
    const {classes} = this.props;

    let area = {
      codigo: '',
      designacao: ''
    };

    let Content = () => {
      return <form autoComplete="off" className={classes.addForm}>
        <CustomInput
          labelText="Código"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            defaultValue: area.codigo,
            onChange: (e) => {
              area.codigo = e.target.value;
            }
          }}
        />
        <CustomInput
          labelText="Designação"
          formControlProps={{
            fullWidth: true
          }}
          helpText="Utilize o formato: CODIGO | Designação"
          inputProps={{
            defaultValue: area.designacao,
            onChange: (e) => {
              area.designacao = e.target.value;
            }
          }}
        />
      </form>
    };

    this.setState({
      modal: (<SweetAlert
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Nova Área</span>
        </div>)}
        onConfirm={async () => {
          await connection.post("modulo/area/nova", {
            codigo: area.codigo,
            designacao: area.designacao,
          });
          this.hideModal();
          this.reloadAreas();
          general.success("Área adicionada com sucesso", "Sucesso");
        }}
        onCancel={() => this.hideModal()}
        cancelBtnText="Cancelar"
        showCancel
        confirmBtnText="Adicionar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <Content/>
      </SweetAlert>)
    });
  };

  editModuloModal = async (modulo) => {
    const {classes} = this.props;

    let detalhes_modulo = await connection.get("modulo/detalhes", {id: modulo.id});
    let grupos_alvo = await connection.get("modulo/grupo_alvo/listagem");

    modulo.ficha = detalhes_modulo.ficha;
    delete modulo.documento_ficha;

    let editorState;
    if (modulo.ficha) {
      let blocks = convertFromHTML(modulo.ficha.split("\n").join("<br/>"));
      if (!blocks.contentBlocks)
        editorState = EditorState.createEmpty();
      else {
        editorState = EditorState.createWithContent(ContentState.createFromBlockArray(blocks));
      }
    } else {
      editorState = EditorState.createEmpty();
    }

    let editorSetMessage = (es) => {
      modulo.ficha = draftToHtml(convertToRaw(es.getCurrentContent()));
    };

    let Content = () => {
      const [area_state, setArea] = useState(modulo.id_area);
      const [id_grupo_alvo_state, setIDGrupoAlvo] = useState(modulo.id_grupo_alvo);
      const [nome_documento, setNomeDocumento] = useState(detalhes_modulo.documento_ficha && detalhes_modulo.documento_ficha.informacoes_ficheiro.name);

      return <form autoComplete="off" className={classes.addForm}>
        <CustomInput
          labelText="Código"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            defaultValue: modulo.codigo,
            onChange: (e) => {
              modulo.codigo = e.target.value;
            }
          }}
        />
        <CustomInput
          labelText="Designação"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            defaultValue: modulo.designacao,
            onChange: (e) => {
              modulo.designacao = e.target.value;
            }
          }}
        />
        <FormControl fullWidth className={classes.selectFormControl}>
          <InputLabel htmlFor="modelo_grupo_alvo" className={classes.selectLabel}>
            Grupo-Alvo
          </InputLabel>
          <Select
            MenuProps={{
              className: classes.selectMenu
            }}
            classes={{
              select: classes.select
            }}
            value={id_grupo_alvo_state}
            onChange={(event) => {
              modulo.id_grupo_alvo = event.target.value;
              setIDGrupoAlvo(event.target.value);
            }}
          >
            <MenuItem disabled classes={{root: classes.selectMenuItem}}>Escolha o grupo-alvo</MenuItem>
            {grupos_alvo.map((grupo) => {
              return <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={grupo.id}>{grupo.designacao}</MenuItem>;
            })}
          </Select>
        </FormControl>
        <FormControl fullWidth className={classes.selectFormControl}>
          <InputLabel className={classes.selectLabel}>
            Permitir utilização isolada
          </InputLabel>
          <Select
            MenuProps={{
              className: classes.selectMenu
            }}
            classes={{
              select: classes.select
            }}
            onChange={(event) => {
              modulo.permitir_isolado = event.target.value;
            }}
            defaultValue={modulo.permitir_isolado}
          >
            <MenuItem classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={0}>Não</MenuItem>
            <MenuItem classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={1}>Sim</MenuItem>
          </Select>
        </FormControl>
        <FormControl fullWidth className={classes.selectFormControl}>
          <InputLabel htmlFor="modelo_area" className={classes.selectLabel}>
            Área
          </InputLabel>
          <Select
            MenuProps={{
              className: classes.selectMenu
            }}
            classes={{
              select: classes.select
            }}
            value={area_state}
            onChange={(event) => {
              modulo.id_area = event.target.value;
              setArea(event.target.value);
            }}
          >
            <MenuItem disabled classes={{root: classes.selectMenuItem}}>Escolha a área</MenuItem>
            {this.state.areas.map((area) => {
              return <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={area.id}>{area.designacao}</MenuItem>;
            })}
          </Select>
        </FormControl>
        <CustomInput
          labelText="Créditos"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "number",
            min: "0",
            max: "10",
            defaultValue: modulo.creditos,
            onChange: (e) => {
              modulo.creditos = e.target.value
            }
          }}
        />
        <CustomInput
          labelText="Validade dos créditos em meses (colocar zero para não aplicar validade)"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "number",
            min: "0",
            defaultValue: modulo.validade_creditos_meses || 0,
            onChange: (e) => {
              modulo.validade_creditos_meses = e.target.value
            }
          }}
        />
        <FormControl fullWidth className={classes.selectFormControl}>
          <InputLabel shrink={true}>
            Ficha do módulo
          </InputLabel>
          <div style={{
            background: "#fbfbfb",
            padding: 5,
            borderRadius: 5,
            marginTop: 20
          }}>
            <Editor
              defaultEditorState={editorState}
              wrapperClassName="wrapper-class"
              editorClassName={"editor-class " + classes.mensagemEditor}
              toolbarClassName={"toolbar-class " + classes.mensagemToolbar}
              onEditorStateChange={(es) => {
                editorState = es;
                editorSetMessage(es);
              }}
              toolbar={{
                options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link', 'remove', 'history'],
              }}
            />
          </div>
        </FormControl>
        <CustomInput
          labelProps={{
            shrink: true
          }}
          labelText={<span>Ficha/Documento {detalhes_modulo.documento_ficha && <a target="_blank" href={connection.getFullUrl(detalhes_modulo.documento_ficha.path)}><br/>{detalhes_modulo.documento_ficha.informacoes_ficheiro.name} <FontAwesomeIcon icon={faFileDownload}/></a>}</span>}
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "file",
            style: detalhes_modulo.documento_ficha ? {marginTop: 12} : null,
            onChange: (e) => {
              if (e.target.files.length > 0) {
                modulo.documento_ficha = e.target.files[0];
                setNomeDocumento(modulo.documento_ficha.name);
              }
            }
          }}
        />
      </form>
    };

    this.setState({
      modal: (<SweetAlert
        style={{width: 700}}
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Editar Módulo</span>
        </div>)}
        onConfirm={async () => {
          let form_data = new FormData();
          form_data.append("id", modulo.id);
          form_data.append("codigo", modulo.codigo);
          form_data.append("designacao", modulo.designacao);
          form_data.append("area", modulo.id_area);
          form_data.append("ficha", modulo.ficha);
          form_data.append("creditos", modulo.creditos);
          form_data.append("validade_creditos_meses", modulo.validade_creditos_meses);
          form_data.append("grupo_alvo", modulo.id_grupo_alvo);
          form_data.append("permitir_isolado", modulo.permitir_isolado);
          if (modulo.documento_ficha)
            form_data.append("documento_ficha", modulo.documento_ficha);

          await connection.post("modulo/editar", form_data);
          this.hideModal();
          this.reloadAreas();
          this.reloadModulos();
          general.success("Módulo editado com sucesso", "Sucesso");
        }}
        onCancel={() => this.hideModal()}
        cancelBtnText="Cancelar"
        showCancel
        confirmBtnText="Salvar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <Content/>
      </SweetAlert>)
    });
  };

  viewModuloModal = async (modulo) => {
    const {classes} = this.props;

    let detalhes_modulo = await connection.get("modulo/detalhes", {id: modulo.id});

    let Content = () => {
      return <div className={classes.details}>
        <Card className={"card"}>
          <CardHeader color="primary">
            <h4 style={{flex: 1}}>{detalhes_modulo.designacao}</h4>
          </CardHeader>
          <CardBody>
            <table>
              <tr>
                <td>Código</td>
                <td>{detalhes_modulo.codigo}</td>
              </tr>
              <tr>
                <td>Área</td>
                <td>{detalhes_modulo.area}</td>
              </tr>
              <tr>
                <td>Créditos</td>
                <td>{detalhes_modulo.creditos}</td>
              </tr>
              <tr>
                <td>Pode ser criado isoladamente</td>
                <td>{detalhes_modulo.permitir_isolado ? "Sim" : "Não"}</td>
              </tr>
            </table>
          </CardBody>
        </Card>
        {(detalhes_modulo.ficha || detalhes_modulo.documento_ficha) && <Card className={"card"}>
          <CardHeader color="primary">
            <h4 style={{flex: 1}}>
              Ficha do Módulo {detalhes_modulo.documento_ficha && <Tooltip
              title="Descarregar ficha"
              placement="top"
              classes={{tooltip: classes.tooltip}}
            >
              <a target="_blank" rel="noopener noreferrer" href={connection.getFullUrl(detalhes_modulo.documento_ficha.path)}> <FontAwesomeIcon color={primaryColor} icon={faFileDownload}/></a>
            </Tooltip>}
            </h4>
          </CardHeader>
          {!detalhes_modulo.documento_ficha && detalhes_modulo.ficha && <CardBody className={classes.courseDetails}>
            <p>{Parser(detalhes_modulo.ficha.trim().split("\n").join("<br/>"))}</p>
          </CardBody>}
          {detalhes_modulo.documento_ficha && <div>
            {detalhes_modulo.documento_ficha.informacoes_ficheiro.mimetype.substr(0, 5) === 'image' ? <img width="100%" src={connection.getFullUrl(detalhes_modulo.documento_ficha.path)}/> :
              <div style={{paddingBottom: "141%", position: "relative"}}>
                <iframe width="100%" style={{border: 0, position: "absolute", top: 0, bottom: 0, left: 0, right: 0, height: "100%"}} src={connection.getFullUrl(detalhes_modulo.documento_ficha.path) + "#toolbar=0&view=Fit&navpanes=0"}/>
              </div>}
          </div>}
        </Card>}
      </div>;
    };

    this.setState({
      modal: (<SweetAlert
        style={{width: 700, backgroundColor: "none"}}
        showConfirm={false}
        onCancel={() => this.hideModal()}
        cancelBtnText="Fechar"
        showCancel
        cancelBtnCssClass={classes.button + " " + classes.success}
      >
        <Content/>
      </SweetAlert>)
    });
  };

  novoModuloModal = async () => {
    const {classes} = this.props;

    let grupos_alvo = await connection.get("modulo/grupo_alvo/listagem");

    let modulo = {
      area: null,
      designacao: '',
      documento_ficha: null,
      ficha: '',
      creditos: 1,
      id_grupo_alvo: null
    };

    let editorState = EditorState.createEmpty();

    let editorSetMessage = (es) => {
      modulo.ficha = draftToHtml(convertToRaw(es.getCurrentContent()));
    };

    let Content = () => {
      const [area_state, setArea] = useState(modulo.area);
      const [id_grupo_alvo_state, setIDGrupoAlvo] = useState(modulo.id_grupo_alvo);
      const [nome_documento, setNomeDocumento] = useState(null);

      return <form autoComplete="off" className={classes.addForm}>
        <CustomInput
          labelText="Código"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            defaultValue: "Será gerado automaticamente",
            disabled: true
          }}
        />
        <CustomInput
          labelText="Designação"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            defaultValue: modulo.designacao,
            onChange: (e) => {
              modulo.designacao = e.target.value;
            }
          }}
        />
        <FormControl fullWidth className={classes.selectFormControl}>
          <InputLabel htmlFor="modelo_grupo_alvo" className={classes.selectLabel}>
            Grupo-Alvo
          </InputLabel>
          <Select
            MenuProps={{
              className: classes.selectMenu
            }}
            classes={{
              select: classes.select
            }}
            value={id_grupo_alvo_state}
            onChange={(event) => {
              modulo.id_grupo_alvo = event.target.value;
              setIDGrupoAlvo(event.target.value);
            }}
          >
            <MenuItem disabled classes={{root: classes.selectMenuItem}}>Escolha o grupo-alvo</MenuItem>
            {grupos_alvo.map((grupo) => {
              return <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={grupo.id}>{grupo.designacao}</MenuItem>;
            })}
          </Select>
        </FormControl>
        <FormControl fullWidth className={classes.selectFormControl}>
          <InputLabel className={classes.selectLabel}>
            Permitir utilização isolada
          </InputLabel>
          <Select
            MenuProps={{
              className: classes.selectMenu
            }}
            classes={{
              select: classes.select
            }}
            onChange={(event) => {
              modulo.permitir_isolado = event.target.value;
            }}
            defaultValue={modulo.permitir_isolado}
          >
            <MenuItem classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={0}>Não</MenuItem>
            <MenuItem classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={1}>Sim</MenuItem>
          </Select>
        </FormControl>
        <FormControl fullWidth className={classes.selectFormControl}>
          <InputLabel htmlFor="modelo_area" className={classes.selectLabel}>
            Área
          </InputLabel>
          <Select
            MenuProps={{
              className: classes.selectMenu
            }}
            classes={{
              select: classes.select
            }}
            value={area_state}
            onChange={(event) => {
              modulo.area = event.target.value;
              setArea(event.target.value);
            }}
            inputProps={{
              name: "modelo_area",
              id: "modelo_area"
            }}
          >
            <MenuItem disabled classes={{root: classes.selectMenuItem}}>Escolha a área</MenuItem>
            {this.state.areas.map((area) => {
              return <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={area.id}>{area.designacao}</MenuItem>;
            })}
          </Select>
        </FormControl>
        <CustomInput
          labelText="Créditos"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "number",
            min: "0",
            max: "10",
            defaultValue: modulo.creditos,
            onChange: (e) => {
              modulo.creditos = e.target.value
            }
          }}
        />
        <CustomInput
          labelText="Validade dos créditos em meses (colocar zero para não aplicar validade)"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "number",
            min: "0",
            defaultValue: modulo.validade_creditos_meses || 0,
            onChange: (e) => {
              modulo.validade_creditos_meses = e.target.value
            }
          }}
        />
        <FormControl fullWidth className={classes.selectFormControl}>
          <InputLabel shrink={true}>
            Ficha do módulo
          </InputLabel>
          <div style={{
            background: "#fbfbfb",
            padding: 5,
            borderRadius: 5,
            marginTop: 20
          }}>
            <Editor
              defaultEditorState={editorState}
              wrapperClassName="wrapper-class"
              editorClassName={"editor-class " + classes.mensagemEditor}
              toolbarClassName={"toolbar-class " + classes.mensagemToolbar}
              onEditorStateChange={(es) => {
                editorState = es;
                editorSetMessage(es);
              }}
              toolbar={{
                options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link', 'remove', 'history'],
              }}
            />
          </div>
        </FormControl>
        <CustomInput
          labelText="Ficha/Documento"
          labelProps={{
            shrink: true
          }}
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "file",
            onChange: (e) => {
              if (e.target.files.length > 0) {
                modulo.documento_ficha = e.target.files[0];
                setNomeDocumento(modulo.documento_ficha.name);
              }
            }
          }}
        />
        {/*nome_documento && <p>{nome_documento}</p>*/}
      </form>
    };

    this.setState({
      modal: (<SweetAlert
        style={{width: 700}}
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Novo Módulo</span>
        </div>)}
        onConfirm={async () => {
          let form_data = new FormData();
          form_data.append("designacao", modulo.designacao);
          form_data.append("area", modulo.area);
          form_data.append("ficha", modulo.ficha);
          form_data.append("creditos", modulo.creditos);
          form_data.append("validade_creditos_meses", modulo.validade_creditos_meses);
          form_data.append("grupo_alvo", modulo.id_grupo_alvo);
          form_data.append("permitir_isolado", modulo.permitir_isolado);
          if (modulo.documento_ficha)
            form_data.append("documento_ficha", modulo.documento_ficha);

          await connection.post("modulo/novo", form_data);
          this.hideModal();
          this.reloadAreas();
          this.reloadModulos();
          general.success("Módulo adicionado com sucesso", "Sucesso");
        }}
        onCancel={() => this.hideModal()}
        cancelBtnText="Cancelar"
        showCancel
        confirmBtnText="Adicionar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <Content/>
      </SweetAlert>)
    });
  };
}

export default withStyles(modulosStyle)(Catalogo);
